export default __webpack_public_path__ + "static/media/VEB_hospitalIndemnity.d39d2700.png";